module.exports = __webpack_public_path__ + "static/img/bnt-invite.233830cc.gif";